import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { ConsumerResponse } from "../Consumer.types";

export const consumerQueries = {
  detail: (consumerId?: number) =>
    queryOptions<ConsumerResponse>({
      queryKey: ["consumer", { consumerId }],
      queryFn: consumerId ? () => fetchConsumer(consumerId) : skipToken,
      enabled: typeof consumerId !== "undefined",
      refetchInterval: false,
      refetchOnWindowFocus: false
    })
};

export function useConsumer(consumerId?: number) {
  return useQuery(consumerQueries.detail(consumerId));
}

async function fetchConsumer(consumerId: number) {
  const response = await apiWithoutCamelization.get<ConsumerResponse>(
    urls.apiWithoutCamelization.consumer(consumerId)
  );
  return response.data;
}
